<template>
  <section class="content-plans-register">
    <Breadcrumb :links="links" :data="this.dataProps"/>
    <form class="content-plans-register-form" @submit.prevent="handleSubmit()">
      <div class="row">
        <div class="col-12">
          <div class="content-input-default">
            <input type="text" name="name" v-model="music.name" value="" placeholder="Nome" required/>
          </div>
        </div>
        <div class="col-12">
          <UploadImage @changePicture="(value) => music.picture = value" :proportion="'Proporção: 400x400'"/>
        </div>
        <div class="col-12">
          <UploadAudio :image="'notas-musicais.png'"/>
        </div>
        <div class="col-12">
          <button class="btn-green">Salvar</button>
        </div>
      </div>
    </form>
  </section>
</template>

<script>
import Breadcrumb from '@/components/breadcrumb/Index';
import UploadImage from '@/components/upload/Index';
import UploadAudio from '@/components/uploadAudio/Index';
import { mapGetters, mapActions } from 'vuex';

export default {
  data() {
    return {
      links: [
        {
          name: 'Meditação',
          routerName: 'Meditation'
        },
        {
          name: 'Nova Música',
          routerName: 'RegisterMusic'
        },
      ],
      music: {
        id_user: "",
        name: '',
        picture: null,
        music: null,
        music_name: '',
        music_time: '',
      },
      musicParams: this.$route.params,
      dataProps: { module: 'Meditation' },
    }
  },
  computed: {
    ...mapGetters({
      user: 'User/user',
      musicData: 'Meditation/musics',
      imageFileUrl: 'imageFileUrl',
      audio: 'audio',
      isPremium: 'Meditation/isPremium'
    })
  },
  components: {
    Breadcrumb,
    UploadImage,
    UploadAudio
  },
  methods: {
    ...mapActions('Meditation', ['registerMusic', 'consultMusics', 'setDataDefault']),
    ...mapActions(['setImageFileUrl', 'setAudio']),
    async handleSubmit(){
      let message = this.music?.id ? 'Música editado com sucesso!' : 'Música cadastrado com sucesso!';

      this.music.id_user = this.user.id;
      this.music.music = this.audio?.blob ?? await this.dowloadFile();
      this.music.music_name = this.audio?.name;
      this.music.music_time = !this.audio.time ? this.music.music_time : this.convertSecondsForTime(this.audio.time);
      this.music.is_premium = this.isPremium;

      await this.registerMusic(this.music);
      this.$router.push({ name: 'Meditation' })
      this.$swal.fire({
        icon: 'success',
        html: message,
      })
    },
    async dowloadFile() {
      try {
        // Baixa o conteúdo do arquivo MP3 da URL
        const response = await fetch(this.music.music_path);
        const mp3ArrayBuffer = await response.arrayBuffer();

        // Criar um Blob
        return new Blob([mp3ArrayBuffer], { type: 'audio/mp3' });

      } catch (error) {
        console.error('Erro ao baixar o arquivo MP3:', error);
      }
    },
    convertSecondsForTime(seconds) {
      const hours = Math.floor(seconds / 3600);
      const minutes = Math.floor((seconds % 3600) / 60);
      const secondsRemaining = seconds % 60;

      return `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}:${secondsRemaining.toFixed(6)}`;
    }
  },
  async mounted() {
    this.music.id_user = await this.user.id;
    this.setImageFileUrl(null);
    this.setAudio(null);
    if (this.musicParams && Object.keys(this.musicParams).length > 0) {
      await this.consultMusics(this.musicParams);
      this.music = this.musicData;
      this.setDataDefault(['SET_IS_PREMIUM', this.music.is_premium]);
      this.dataProps = {
        name: this.music.name,
        id: this.music.id,
        module: 'Meditation',
        type: 'MeditationMusic'
      };
      this.setImageFileUrl(this.music.picture);
      let obj = {
        name: this.music.music_name,
        url: this.music.music_path,
      };
      this.setAudio(obj);
      this.links[1].name = this.music.name;
    }
  }
}
</script>

<style lang="scss" scoped>
.content-plans-register {
  padding-bottom: 50px;
}
.content-input-default {
  textarea {
    min-height: 250px;
  }
}
.btn-green {
  margin-top: 100px;
  @media (max-width: 991px){
    margin-top: 50px;
  }
}
</style>
